import { ALT_CTA_COPY } from '@chegg-wt/core/components/Dashboard/constants'
import { DashboardUpsellCopy } from '@chegg-wt/core/types/features'

export const getUpsellCopy = (upsellCopy: DashboardUpsellCopy, isFreeTrial = true) => {
  return isFreeTrial
    ? upsellCopy
    : {
        ...upsellCopy,
        citationsCTA: {
          ...upsellCopy.citationsCTA,
          CTA_COPY: ALT_CTA_COPY,
        },
      }
}
